import { Controller } from "@hotwired/stimulus"

/**
 * AutoSubmitController
 * 
 * Automatically submits a form when a trigger element changes.
 * Replaces inline `onchange="this.form.submit()"` handlers.
 * 
 * @example Basic usage with checkbox
 *   <form data-controller="auto-submit">
 *     <input type="checkbox" data-action="change->auto-submit#submit">
 *   </form>
 * 
 * @example With select dropdown
 *   <form data-controller="auto-submit">
 *     <select data-action="change->auto-submit#submit">
 *       <option>Option 1</option>
 *     </select>
 *   </form>
 */
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
